import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

export const V2_MODULES = {
  "/letters": "Letters & Messaging",
  "/print": "Print Center",
  "/telehealth": "Telehealth Videoing",
  "/asam": "ASAM",
  "/users": "Administrative Module",
  "/clinical/crisis-plans": "Crisis or Safety Plan",
  "/engagement/insurance-verification": "Insurance Verification (EDI 270/271)",
  "/engagement/orientation-checklist": "Orientation Checklist",
  "/admin/configuration": "Configuration Library",
  "/signatures": "Signature Audit Console",
  "/medical/ddi-audit": "DDI Override Audit",
};

export const isV2Path = (p) =>
  Object.keys(V2_MODULES).some((v) => p === v || (v !== "/users" && p.startsWith(v + "/")));

export const v2ModuleLabel = (p) => {
  const key = Object.keys(V2_MODULES).find((v) => p === v || (v !== "/users" && p.startsWith(v + "/")));
  return key ? V2_MODULES[key] : "This module";
};

const Ctx = createContext({ v2Enabled: null });

export function V2Provider({ children }) {
  const { user } = useAuth();
  const [v2Enabled, setV2Enabled] = useState(null);
  useEffect(() => {
    if (!user) { setV2Enabled(null); return; }
    api.get("/config/features").then((r) => setV2Enabled(!!r.data.v2_enabled)).catch(() => setV2Enabled(false));
  }, [user]);
  return <Ctx.Provider value={{ v2Enabled }}>{children}</Ctx.Provider>;
}

export const useV2 = () => useContext(Ctx);
